import React from 'react';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Component from '../../components/Component';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, Tab, Tabs, Typography } from '@mui/material';
import ReportUsers from './ReportUsers';
import ReportPosts from './ReportPosts';

function ReportDashboard() {
  const location = useLocation();
  const tabValue = location.pathname.includes('/posts') ? 'posts' : 'users';

  return (
    <Component>
      <div className="page-body">
        <div className="container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-sm-8 d-flex align-items-center">
                <IconButton
                  style={{ background: '#FFFFFF', marginRight: 8 }}
                  component={Link}
                  to="/"
                >
                  <ArrowBackIcon />
                </IconButton>
                <div>
                  <h3 style={{ margin: 0 }}>Report Dashboard</h3>
                  <Typography variant="body2" color="text.secondary">
                    Moderate reported users and posts
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs value={tabValue} aria-label="Report dashboard tabs">
              <Tab
                label="Report User"
                value="users"
                component={Link}
                to="/admin/reports/users"
              />
              <Tab
                label="Report Post"
                value="posts"
                component={Link}
                to="/admin/reports/posts"
              />
            </Tabs>
          </Box>

          <Routes>
            <Route index element={<Navigate to="users" replace />} />
            <Route path="users" element={<ReportUsers />} />
            <Route path="posts" element={<ReportPosts />} />
            <Route path="*" element={<Navigate to="users" replace />} />
          </Routes>
        </div>
      </div>
    </Component>
  );
}

export default ReportDashboard;
